/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MessageLevelEnum } from './messageLevelEnum';
import { MessageTypeEnum } from './messageTypeEnum';
import { Message } from './message';
import { ServiceTypeEnum } from './serviceTypeEnum';
import { MessageReplyTo } from './messageReplyTo';
import { MessageRecipient } from './messageRecipient';


export interface NotificationMessageRequest { 
    /**
     * Time after which the notification should expire. This could be time in seconds, minutes, hours and days.
     */
    expires_in?: string;
    /**
     * Email id for \'from\'. Default value \'donotreply@vmware.com\'.
     */
    from?: string;
    level?: MessageLevelEnum;
    message: Message;
    recipient?: MessageRecipient;
    reply_to?: MessageReplyTo;
    service_type: ServiceTypeEnum;
    type: MessageTypeEnum;
}
export namespace NotificationMessageRequest {
}


